import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useMobileData } from '../MobileDataContext'
import { MTopbar } from '../MobileLayout'
import type { SessionSummary } from '../../api/types'

export default function MExamCreate() {
  const navigate = useNavigate()
  const { t } = useTranslation('pages')
  const { classes, addExam } = useMobileData()

  const [name, setName] = useState('')
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10))
  const [classId, setClassId] = useState<number | ''>('')
  const [maxPoints, setMaxPoints] = useState('100')
  const [description, setDescription] = useState('')

  const canSubmit = name.trim().length > 0 && classId !== ''

  const submit = () => {
    if (!canSubmit) return
    const id = Math.floor(Date.now() / 1000)
    const exam: SessionSummary = {
      id,
      session_name: name.trim(),
      test_date: date,
      class_id: typeof classId === 'number' ? classId : null,
      description: description.trim() || null,
      created_at: new Date().toISOString(),
    }
    addExam(exam)
    navigate(`/m/exams/${id}/setup`)
  }

  return (
    <>
      <MTopbar title={t('mobile.examCreate.title')} back backTo="/m" />
      <div className="m-scroll">
        <div className="m-page">
          <div className="m-field">
            <label className="m-label">{t('mobile.examCreate.nameLabel')}</label>
            <input
              className="m-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t('mobile.examCreate.namePlaceholder')}
              autoFocus
            />
          </div>

          <div className="m-field">
            <label className="m-label">{t('mobile.examCreate.dateLabel')}</label>
            <input className="m-input" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
          </div>

          <div className="m-field">
            <label className="m-label">{t('mobile.examCreate.classLabel')}</label>
            <select
              className="m-select"
              value={classId}
              onChange={(e) => setClassId(e.target.value === '' ? '' : Number(e.target.value))}
            >
              <option value="">{t('mobile.examCreate.classPlaceholder')}</option>
              {classes.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>

          <div className="m-field">
            <label className="m-label">{t('mobile.examCreate.maxPointsLabel')}</label>
            <input
              className="m-input"
              type="number"
              inputMode="numeric"
              value={maxPoints}
              onChange={(e) => setMaxPoints(e.target.value)}
            />
          </div>

          <div className="m-field">
            <label className="m-label">{t('mobile.examCreate.descLabel')}</label>
            <textarea
              className="m-textarea"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder={t('mobile.examCreate.descPlaceholder')}
            />
          </div>
        </div>
      </div>
      <div className="m-actionbar">
        <button className="m-btn m-btn--primary m-btn--block m-btn--lg" disabled={!canSubmit} onClick={submit}>
          {t('mobile.examCreate.submit')}
        </button>
      </div>
    </>
  )
}
